/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CouponLinkLangViewModel } from "../types/CouponLinkLangViewModel.ts";

export const couponLinkLangViewModelSchema = z.object({
  culture: z.string().describe("Código do idioma (cultura) do link.").nullish(),
  link: z
    .string()
    .describe(
      "URL de matrícula da ficha nova, com os parâmetros criptografados no id (para aplicar o cupom) e o idioma na query string.",
    )
    .nullish(),
}) as unknown as ToZod<CouponLinkLangViewModel>;
